export default "__VITE_ASSET__17fb48d2__"